'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { SearchX, Home, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { interactiveLinkClass } from '@/lib/ui/interactive-link';
export default function NotFound() {
  const $ = _c(67);
  const {
    t
  } = useTranslation("legal");
  const {
    t: tn
  } = useTranslation("nav");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-6 flex justify-center"><div className="rounded-full bg-blue-100 p-6 dark:bg-blue-900/20"><SearchX className="h-16 w-16 text-blue-600 dark:text-blue-400" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("notFoundCode");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h1 className="mb-2 text-6xl font-bold text-gray-900 dark:text-white">{t1}</h1>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("notFoundTitle");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <h2 className="mb-3 text-2xl font-semibold text-gray-800 dark:text-gray-200">{t3}</h2>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("notFoundDescription");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p className="mb-8 text-gray-600 dark:text-gray-400">{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Home className="mr-2 h-4 w-4" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("backToDashboard");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Button asChild={true}><Link href="/dashboard">{t7}{t8}</Link></Button>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ArrowLeft className="mr-2 h-4 w-4" />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("goBack");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <Button variant="outline" onClick={_temp}>{t10}{t11}</Button>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t9) {
    t13 = <div className="flex flex-col justify-center gap-3 sm:flex-row">{t9}{t12}</div>;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t("commonPagesTitle");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <p className="text-sm text-gray-600 dark:text-gray-400"><strong>{t14}</strong></p>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = interactiveLinkClass({
      primary: true,
      className: "text-sm"
    });
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== tn) {
    t17 = tn("devices");
    $[31] = tn;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t17) {
    t18 = <Link href="/devices" className={t16}>{t17}</Link>;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <span className="text-gray-400">•</span>;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = interactiveLinkClass({
      primary: true,
      className: "text-sm"
    });
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== tn) {
    t21 = tn("users");
    $[37] = tn;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t21) {
    t22 = <Link href="/users" className={t20}>{t21}</Link>;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <span className="text-gray-400">•</span>;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = interactiveLinkClass({
      primary: true,
      className: "text-sm"
    });
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== tn) {
    t25 = tn("attendance");
    $[43] = tn;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t25) {
    t26 = <Link href="/attendance" className={t24}>{t25}</Link>;
    $[45] = t25;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <span className="text-gray-400">•</span>;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = interactiveLinkClass({
      primary: true,
      className: "text-sm"
    });
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== tn) {
    t29 = tn("profile");
    $[49] = tn;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== t29) {
    t30 = <Link href="/profile" className={t28}>{t29}</Link>;
    $[51] = t29;
    $[52] = t30;
  } else {
    t30 = $[52];
  }
  let t31;
  if ($[53] !== t18 || $[54] !== t22 || $[55] !== t26 || $[56] !== t30) {
    t31 = <div className="mt-3 flex flex-wrap justify-center gap-2">{t18}{t19}{t22}{t23}{t26}{t27}{t30}</div>;
    $[53] = t18;
    $[54] = t22;
    $[55] = t26;
    $[56] = t30;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] !== t15 || $[59] !== t31) {
    t32 = <div className="mt-8 rounded-lg bg-gray-100 p-4 dark:bg-gray-800">{t15}{t31}</div>;
    $[58] = t15;
    $[59] = t31;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] !== t13 || $[62] !== t2 || $[63] !== t32 || $[64] !== t4 || $[65] !== t6) {
    t33 = <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 px-4 dark:from-gray-900 dark:to-gray-800"><div className="w-full max-w-md text-center">{t0}{t2}{t4}{t6}{t13}{t32}</div></div>;
    $[61] = t13;
    $[62] = t2;
    $[63] = t32;
    $[64] = t4;
    $[65] = t6;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  return t33;
}
function _temp() {
  if (typeof window !== "undefined") {
    window.history.back();
  }
}